// Files as phone rows (the type in a coloured square, the name, size, who and when, where it came from), and the
// Add file sheet: choose a file from the phone, or tell the assistant where to find it.
import { useRef } from 'react';
import type { FileItem } from '@dpw/shared';
import { agoStart, bytes, ext } from '../lib/format';
import { download } from '../ui/FileList';
import { P, PSheet } from './kit';
import { useAssistantPanel } from '../assistant/Panel';
import { useInboundAddress } from '../ui/email';

const FIC: Record<string, string> = { doc: 'doc', docx: 'doc', pdf: 'pdf', xls: 'xls', xlsx: 'xls', csv: 'xls', png: 'img', jpg: 'img', jpeg: 'img', ppt: 'doc', pptx: 'doc' };

export function FileRows({ files, where }: { files: FileItem[]; where?: boolean }) {
  return (
    <div className="ph-grp" role="group" aria-label="Files">
      {files.map(f => {
        const x = ext(f.name).toLowerCase();
        return (
          <button key={f.id} type="button" className="ph-row" onClick={() => void download(f)} aria-label={`Open ${f.name}`}>
            <span className={`ph-fic ${FIC[x] ?? ''}`}>{x || 'file'}</span>
            <span className="ph-rt"><div className="t">{f.name}</div>
              <div className="s">{[bytes(f.size), f.addedBy?.name.split(' ')[0], agoStart(f.createdAt)].filter(Boolean).join(' · ')}{where && f.activityTitle ? ` · from ${f.activityTitle}` : ''}</div></span>
          </button>
        );
      })}
      {!files.length && <div className="ph-rowx"><span className="ph-rt"><div className="s">Nothing of this kind yet.</div></span></div>}
    </div>
  );
}

export function AddFileSheet({ title, ask, onPick, onClose }: { title: string; ask: string; onPick: (f: File) => void; onClose: () => void }) {
  const input = useRef<HTMLInputElement>(null);
  const addr = useInboundAddress();
  const panel = useAssistantPanel();
  return (
    <PSheet label={title} onClose={onClose}>
      <h2>{title}</h2>
      <div className="ph-grp flat">
        <button type="button" className="ph-opt3" onClick={() => input.current?.click()}><span className="ph-ic"><P.clip /></span><span className="ph-rt"><div className="t">Choose a file</div><div className="s">From this phone or its cloud drives</div></span></button>
        <button type="button" className="ph-opt3 ai" onClick={() => { onClose(); panel.open({ prompt: ask }); }}><span className="ph-ic aio"><span className="aiorb lg" /></span><span className="ph-rt"><div className="t">Tell the assistant</div><div className="s">Say where it is, or forward it to {addr ?? 'the log address'}</div></span></button>
      </div>
      <input ref={input} type="file" hidden onChange={e => { const f = e.target.files?.[0]; if (f) { onPick(f); onClose(); } e.target.value = ''; }} />
    </PSheet>
  );
}
